const messages = {
  title: "Accès refusé",
  description: "Vous n'avez pas accès à cette ressource.",
  backHomeButton: "Retour au tableau de bord",
}

export default {
  messages
}
